// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.stepper[data-v-33d3dc65] {\n  -webkit-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n  overflow: hidden;\n  height: 120px;\n}\n.stepper.-enlarge[data-v-33d3dc65] {\n  height: 0px;\n}\n.title[data-v-33d3dc65] {\n  -webkit-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n  overflow: hidden;\n}\n.title.-enlarge[data-v-33d3dc65] {\n  font-size: 0px !important;\n  line-height: 0px !important;\n}\n", ""]);
// Exports
module.exports = exports;
